import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../utils/api';

const VerifyEmail = () => {
  const [message, setMessage] = useState('Verifying your email...');
  const [isSuccess, setIsSuccess] = useState(false);
  
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await api.get(`/auth/verify-email/${token}`);
        setMessage(response.data.message);
        setIsSuccess(true);
        
        // Redirect to login page after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
        
      } catch (err) {
        setMessage(err.response?.data?.message || 'Email verification failed. Invalid or expired token.');
        setIsSuccess(false);
      }
    };
    
    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="max-w-md mx-auto bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md mt-10">
      <h1 className="text-2xl font-bold text-center mb-6 text-blue-600 dark:text-blue-400">Email Verification</h1>
      
      <div className={`border-l-4 p-4 mb-4 ${
        isSuccess 
          ? 'bg-green-100 border-green-500 text-green-700 dark:bg-green-900 dark:text-green-300' 
          : 'bg-yellow-100 border-yellow-500 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300'
      }`} role="alert">
        <p>{message}</p>
        {isSuccess && <p className="mt-2 text-sm">Redirecting to login page...</p>}
      </div>
      
      <div className="flex justify-center">
        <button
          onClick={() => navigate('/login')}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default VerifyEmail;
